import React from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import { AdminAuthorizedPartners, CreateAuthorizedPdf, Login, PdfHistory, SearchPdf, EditAuthorizedPdf } from 'pages';
import { ROUTES } from 'constants/routes';
import { About } from './pages';
import { Register } from './pages';
import { Documents } from './pages';
import { Profile } from './pages';
import { EditOriginalPdf } from './pages';
import { SerialNumbers } from './pages/SerialNumbers';
import { FleetListPage } from './pages/FleetList/FleetList';
import { RegistrationHistoryPage } from './pages/RegistrationHistory/RegistrationHistory';
import { AuthorizedPartners } from './pages';

export const router = createBrowserRouter([
  {
    path: ROUTES.root,
    element: <Navigate to="/search-pdf" />,
  },
  {
    path: ROUTES.login,
    element: <Login />,
  },
  {
    path: ROUTES.register,
    element: <Register />,
  },
  {
    path: ROUTES.about,
    element: <About />,
  },
  {
    path: ROUTES.authorized_partners,
    element: <AuthorizedPartners />,
  },
  {
    path: ROUTES.create_authorized,
    element: <CreateAuthorizedPdf />,
  },
  {
    path: ROUTES.search_pdf,
    element: <SearchPdf />,
  },
  {
    path: ROUTES.pdf_history,
    element: <PdfHistory />,
  },
  {
    path: ROUTES.registration_history,
    element: <SerialNumbers />,
  },
  {
    path: `${ROUTES.edit_authorized}/:certId`,
    element: <EditAuthorizedPdf />,
  },
  {
    path: `${ROUTES.edit_original}/:sn/:commissioningToken?`,
    element: <EditOriginalPdf />,
  },
  {
    path: `${ROUTES.documents_overview}/:sn/:certId?`,
    element: <Documents />,
  },
  {
    path: `${ROUTES.profile}`,
    element: <Profile />,
  },
  {
    path: ROUTES.fleet_list,
    element: <FleetListPage />,
  },
  {
    path: ROUTES.registration_history_shipping,
    element: <RegistrationHistoryPage />,
  },
  {
    path: ROUTES.admin,
    element: <Navigate to={ROUTES.admin_authorized_partners} replace />,
  },
  {
    path: ROUTES.admin_authorized_partners,
    element: <AdminAuthorizedPartners />,
  },
]);

function App() {
  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}

export default App;
